<template>
  <canvas-page :terminal="4" :typeId="1"></canvas-page>
</template>

<script>
  import CanvasPage from '../../components/canvasShow/canvasShowPage';
  import api from '@/api'
  import { listSearchMixin } from '@/config/mixin'
  import Cookie from "js-cookie";
  export default {
    name: 'index',
    components: { CanvasPage },
    mixins: [listSearchMixin],
    data () {
      return {
        canvasData: []
      }
    },
    mounted () {
      if(Cookie.get("token")){
        //首页判断账号是否认证过,没有的话,提示去认证,未登录的话不用管
        let params = {
          url: api.enterprisePass,
          method: "POST",
          data: {},
        };

        this.sendReq(params, (res) => {
            if (res.code !== "200" && res.code !== "40014" && Cookie.get("needCheckPass") != 0) {
              // this.$confirm({
              //   title: '机构认证',
              //   content: h => {
              //     return <div>
              //               <div style="font-size:14px;margin-bottom:10px;">您当前还没有进行过机构认证,<span style="font-size:15px;margin-left:2px;color:#ff4d4f;">需认证后才可以进行购买商品</span></div>
              //               <div>您也可以从<span style="font-size:12px;margin:0 4px;color:#999;">个人中心->机构认证</span>进入提交认证,未认证不会影响您浏览商品</div>
              //     </div>
              //   },
              //   icon:'exclamation-circle',
              //   width:600,
              //   cancelText: '下次再说',
              //   okText: '立即认证',
              //   okType: 'danger',
              //   onOk:()=>{
              //     this.$router.push({
              //       path: '/companyCertificate',
              //     })
              //   },
              //   onCancel() {
              //     Cookie.set("needCheckPass", 0, { expires: 1 });
              //   },
              // });
            }
          }
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/home/index.vue